import GroupsIcon from '@mui/icons-material/Groups'
import { routeFrontOfficeManageUserTeam } from '@/lib/routes/front/common/routeFrontOfficeManageUserTeam'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeSchoolManagerLearner = [
  {
    route: 'ManageTeam',
    text: 'Pilotage de mon équipe',
    t: 'routes.frontoffice.school.manageTeam',
    mobileText: 'Equipe',
    icon: GroupsIcon,
    href: '/frontoffice/school/manage-team',
    menuHeader: true,
    position: 20,
    positionMobile: 400,
  },
  // Page de redirection vers la section « À attribuer » de la Formathèque : plus d'entrée de menu,
  // mais la route reste déclarée, sans quoi withAuthent renverrait vers l'accueil.
  {
    route: 'ToAssignTrainings',
    href: '/frontoffice/school/training/to-assign-trainings',
    text: 'Formations à attribuer',
    t: 'routes.frontoffice.school.trainingToAssign',
    menuHeader: false,
  },
  ...routeFrontOfficeManageUserTeam,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_MANAGER_LEARNER],
}))
